import { gql } from 'react-apollo';

import {
  SHOW_BLOG_PHOTOS_START,
  SHOW_BLOG_PHOTOS_SUCCESS,
  SHOW_BLOG_PHOTOS_ERROR
} from '../constants';

const query = gql`
  query blogPhotos($blogId:Int!) {
    ShowBlogPhotos (blogId:$blogId) {
      id
      blogId
      number
      name
      type
      isCover
    }
  }
`;

export function getBlogPhotos(blogId) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: SHOW_BLOG_PHOTOS_START,
    });

    try {
      let id = Number(blogId);
      // Send Request to get blog data
      const { data } = await client.query({
        query,
        variables: { blogId: id },
        order: [['number', 'ASC']],
        fetchPolicy: 'network-only'
      });


      if (data && data.ShowBlogPhotos) {
        dispatch({
          type: SHOW_BLOG_PHOTOS_SUCCESS,
          blogPhotos: data.ShowBlogPhotos,
          photosCount: data.ShowBlogPhotos.length
        });
      } else {
        dispatch({
          type: SHOW_BLOG_PHOTOS_ERROR,
        });
      }
    } catch (error) {
      dispatch({
        type: SHOW_BLOG_PHOTOS_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}



// WEBPACK FOOTER //
// src/actions/getBlogPhotos.js